import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'hpf-gallery',
  templateUrl: './gallery.component.html'
})
export class GalleryComponent implements OnInit {

  /** Constructor */
  constructor() {}

  /** Init */
  ngOnInit() {}

}
